import { N200 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import styled, { css } from 'styled-components';

type DescriptionProps = {
    topMargin?: string;
};

type LabelProps = {
    bottomMargin?: string;
};

export const SpinnerArea = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 10px;
`;

export const Column = styled.div`
    display: flex;
    flex-direction: column;
`;

export const ColumnCss = css`
    display: flex;
    flex-direction: column;
`;

export const Description = styled.div`
    margin-top: 4px;
    color: ${token('color.text.subtle', N200)};
    font-weight: 400;
    font-style: normal;
    line-height: 18px;
    font-size: 12px;
`;

export const ColumnFullWidth = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-bottom: 20px;
`;

export const SelectDescription = styled.div<DescriptionProps>`
    font-weight: 400;
    font-size: 11px;
    color: ${token('color.text.subtlest', N200)};
    margin-top: ${props => (props.topMargin ? props.topMargin : '0')};
`;

export const Label = styled.div<LabelProps>`
    font-weight: bold;
    font-size: 12px;
    color: ${token('color.text.subtlest', N200)};
    margin-bottom: ${props => (props.bottomMargin ? props.bottomMargin : '0')};
`;
